import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { useThemeColor } from "./useThemeColor.js";
const TuneIcon = forwardRef(
  ({ backgroundColor: propBackgroundColor = "#f6f7f8", ...props }, ref) => {
    const getColor = useThemeColor();
    const backgroundColor = getColor(propBackgroundColor);
    return /* @__PURE__ */ jsx(SvgIcon, { ...props, ref, children: /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "26.161", height: "25.152", viewBox: "0 0 26.161 25.152", children: /* @__PURE__ */ jsxs("g", { id: "Group_9998", "data-name": "Group 9998", transform: "translate(0.197)", children: [
      /* @__PURE__ */ jsx(
        "line",
        {
          id: "Line_305",
          "data-name": "Line 305",
          stroke: "currentColor",
          fill: "none",
          strokeWidth: "2px",
          strokeLinecap: "round",
          x2: "22.554",
          transform: "translate(2.41 5.565)"
        }
      ),
      /* @__PURE__ */ jsx(
        "line",
        {
          id: "Line_306",
          "data-name": "Line 306",
          stroke: "currentColor",
          strokeWidth: "2px",
          strokeLinecap: "round",
          fill: "none",
          x2: "22.497",
          transform: "translate(0.803 19.588)"
        }
      ),
      /* @__PURE__ */ jsxs(
        "g",
        {
          id: "Ellipse_78",
          "data-name": "Ellipse 78",
          stroke: "currentColor",
          fill: backgroundColor,
          strokeWidth: "2px",
          transform: "translate(14.462 14.023)",
          children: [
            /* @__PURE__ */ jsx("circle", { stroke: "none", cx: "5.565", cy: "5.565", r: "5.565" }),
            /* @__PURE__ */ jsx("circle", { fill: "none", cx: "5.565", cy: "5.565", r: "4.565" })
          ]
        }
      ),
      /* @__PURE__ */ jsxs("g", { id: "Ellipse_79", "data-name": "Ellipse 79", fill: backgroundColor, strokeWidth: "2px", stroke: "currentColor", children: [
        /* @__PURE__ */ jsx("circle", { stroke: "none", cx: "5.565", cy: "5.565", r: "5.565" }),
        /* @__PURE__ */ jsx("circle", { fill: "none", cx: "5.565", cy: "5.565", r: "4.565" })
      ] })
    ] }) }) });
  }
);
export {
  TuneIcon
};
//# sourceMappingURL=TuneIcon.js.map
